var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box",class:[_vm.settings.color, 'box-' + _vm.settings.size, _vm.extraClass],style:('transform: rotate('+_vm.settings.rotate+'deg);')})}
var staticRenderFns = []

export { render, staticRenderFns }